import { FC, cloneElement, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import { ReactComponent as Highlight } from "../../../assets/svgs/Highlight.svg";
import { SubRoute } from "../sideMenu.routes";
import OnahBadge from "components/onahBadge";

type Props = {
  id: number;
  label: string;
  path: string;
  icon?: any;
  subRoutes?: Array<SubRoute>;
};

const SubMenu: FC<Props> = (data) => {
  const { pathname } = useLocation();
  const [subMenuOpen, setSubMenuOpen] = useState(() => {
    const { subRoutes } = data;
    return !!subRoutes?.find((route) =>
      route.link.toLowerCase().includes(pathname)
    );
  });

  // Check if subRoutes exist
  const hasSubRoutes = data.subRoutes && data.subRoutes.length > 0;

  useEffect(() => {
    const isActive = !!data.subRoutes?.find((route) =>
      pathname.toLowerCase().includes(route.link.toLowerCase())
    );
    setSubMenuOpen(isActive);
  }, [pathname, data.subRoutes]);

  const handleClick = () => {
    setSubMenuOpen(!subMenuOpen);
  };

  const isActive = pathname.toLowerCase().includes(data.label.toLowerCase());

  return (
    <div>
      {hasSubRoutes && (
        // Render submenu
        <li
          className={classNames(
            "py-4 max-2xl:py-3 px-[12px] max-2xl:px-[14px] flex",
            "space-x-[16px] items-center rounded-lg group hover:bg-primary-cta",
            isActive ? "bg-primary-cta" : ""
          )}
          onClick={handleClick}
          key={data.id}
          role="button"
        >
          <data.icon
            className={classNames(
              "group-hover:!text-orange-secondary",
              isActive ? "text-orange-secondary" : ""
            )}
          />
          <span
            className={classNames(
              "group-hover:!text-white",
              isActive ? "text-white" : ""
            )}
          >
            {data.label}
          </span>
        </li>
      )}

      {/* Render submenu if it exists */}
      {hasSubRoutes && (
        <motion.ul
          animate={
            subMenuOpen
              ? {
                  height: "fit-content",
                }
              : {
                  height: 0,
                }
          }
          className="flex flex-col text-lg max-2xl:text-sm font-semibold overflow-hidden ml-[34px] gap-[2px]"
        >
          {data.subRoutes?.map((menu) => (
            <li key={menu.name}>
              <NavLink
                to={menu.link}
                key={menu.name}
                className={classNames(
                  "flex items-center justify-between text-gray-placeholder group",
                  "[&.active]:text-orange-secondary py-[14px] pl-[10px] space-x-[6px]"
                )}
              >
                <div className="flex items-center space-x-[6px]">
                  <Highlight
                    className={classNames(
                      "group-hover:text-orange-secondary",
                      "group-[&.active]:text-orange-secondary"
                    )}
                  />
                  <span
                    className={classNames("group-hover:text-orange-secondary")}
                  >
                    {menu.name}
                  </span>
                </div>
                {menu.badge ? 
                  (typeof menu.badge === 'string' || typeof menu.badge === 'number') ? (
                    <OnahBadge badge={menu.badge}/>
                  ) : 
                  cloneElement(menu.badge, {isActive}) : 
                  null
                }
              </NavLink>
            </li>
          ))}
        </motion.ul>
      )}
    </div>
  );
};

export default SubMenu;
